<script setup>
import { Link } from '@inertiajs/vue3'
import { PhoneIcon } from '@heroicons/vue/24/outline'
import { index as contactIndex } from '@/actions/App/Http/Controllers/ContactController'
import { usePage } from '@inertiajs/vue3'
</script>

<template>
    <section class="relative flex min-h-screen items-center justify-center overflow-hidden">
        <div class="absolute h-full w-full bg-black/75">
            <img
                src="/images/uvod_fotka.webp"
                loading="eager"
                class="min-h-screen w-full object-cover"
                alt="Kalianko - profesionální instalatérské služby"
            />
        </div>
        <span class="absolute z-20 h-full w-full bg-linear-to-b from-black/60 via-black/70 to-black/80" />

        <div class="z-20 space-y-8 px-5 pt-14 text-center lg:px-0 xl:pt-28 2xl:pt-14">
            <div class="mx-auto max-w-4xl space-y-6 lg:mx-0">
                <div>
                    <img
                        class="mx-auto w-40 rounded-[3.5rem] bg-white/50 p-5 backdrop-blur-lg md:w-[28rem] xl:w-[24rem] 2xl:w-[28rem]"
                        src="images/kalianko-logo.png"
                        alt="Kalianko logo"
                    />
                </div>

                <h1 class="text-center text-4xl font-extrabold tracking-tight text-white sm:text-5xl lg:text-6xl">
                    Profesionální instalatérské <br class="hidden sm:inline" />
                    <span class="text-brand-primary">služby</span> pro váš domov
                </h1>

                <p class="mx-auto max-w-2xl text-lg text-gray-300 sm:text-xl">
                    Vodoinstalace, topenářství a plynoinstalace. Jsme rodinná firma s více než 30 lety zkušeností.
                    Kvalita, spolehlivost a lidské jednání.
                </p>
            </div>

            <div class="flex flex-col items-center justify-center gap-4 pt-4 sm:flex-row">
                <Link
                    :href="contactIndex()"
                    class="primary-link inline-flex w-full items-center justify-center rounded-full text-lg lg:w-fit"
                    aria-label="Nezávazná poptávka"
                >
                    Nezávazná poptávka
                </Link>

                <a
                    :href="'tel:' + usePage().props.contacts?.phone?.replace(/\s/g, '')"
                    class="inline-flex w-full items-center justify-center rounded-full border border-white/30 bg-white/10 px-6 py-3 text-lg font-semibold text-white backdrop-blur-lg transition hover:bg-white/20 sm:w-auto"
                    aria-label="Zavolejte nám"
                >
                    <PhoneIcon class="mr-2 size-5" />
                    {{ usePage().props.contacts?.phone ?? '+420 123 456 789' }}
                </a>
            </div>

            <!-- Scroll indicator -->
            <div class="invisible pt-12">
                <div class="mx-auto flex animate-bounce flex-col items-center text-white/60">
                    <span class="mb-2 text-xs tracking-widest uppercase">Zjistit více</span>
                    <svg
                        class="size-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M19 14l-7 7m0 0l-7-7m7 7V3"
                        />
                    </svg>
                </div>
            </div>
        </div>
    </section>
</template>
